/* eslint-disable camelcase */
import {
    TRACKING_INFORMATION_ACTION_REVEAL,
    TrackType,
    TrackingErrorType,
    TrackingInformationTrigger,
    TrackingLoginStatus,
    trackIt,
} from '@vfde-sails/tracking';
import {
    formatToTrackingString,
    getTrackingDiscount,
    getTrackingProduct,
    getTrackingProposition,
    pageLevels,
} from './util';
import { TrackingError, TrackingInformation, TrackingPayload } from './interface';
import { ApiErrorResponseWithCode } from '@vfde-sails/utils';
import { HttpStatus } from '../enum';
import { isApiError } from '../util/typeGuard';
import { TrackingUIType } from './enum';
import { JarvisProduct } from '../interface';

export const trackPageView = (product: JarvisProduct) => {
    const payload: TrackingPayload = {
        login_status: TrackingLoginStatus.NotLoggedIn,
        page_levels: pageLevels,
        page_type: 'product detail',
        site_area: 'fixnet',
        platform_type: 'responsive',
        flow_type: 'tv_flow',
        business_transaction_type: 'fixnet>kud',
        oOrder: {
            aPropositions: [
                getTrackingProposition(product),
            ],
            aProducts: [
                getTrackingProduct(product),
                getTrackingDiscount(product),
            ],
        },
    };

    trackIt(TrackType.PageView, payload);
};

export const trackApiError = (error: ApiErrorResponseWithCode) => {
    const errorType = error.status === HttpStatus.BAD_REQUEST
        ? TrackingErrorType.Validation
        : TrackingErrorType.Technical;

    const payload: TrackingError = {
        error_action: 'displayed',
        error_type: errorType,
        error_message: error.message,
        error_code: error.status.toString(),
    };

    trackIt(TrackType.Error, payload);
};

export const trackAppError = (error: any) => {
    const payload: TrackingError = {
        error_action: 'displayed',
        error_type: TrackingErrorType.Technical,
        error_message: 'message' in error ? error.message : '',
        error_code: '',
    };

    trackIt(TrackType.Error, payload);
};

export const trackError = (error: unknown) =>
    isApiError(error)
        ? trackApiError(error)
        : trackAppError(error);

export const trackAccordion = (headline: string, type: TrackingUIType) => {
    const payload: TrackingInformation = {
        information_action: TRACKING_INFORMATION_ACTION_REVEAL,
        information_name: formatToTrackingString(headline),
        information_ui_type: type,
        information_trigger: TrackingInformationTrigger.Accordion,
    };

    trackIt(TrackType.Information, payload);
};
